import URLConfig from '@Config/urls/url.config';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { FaArrowLeft } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import OpposingCardDetailsHandler from '../../containers/mixedHandlers/cardOperations/opposition/OpposingCardDetailsHandler';

const OppositionDetailPage = () => {

    const {pathname} = useLocation();
    const arr = pathname.split('/');
            
    const bg = CC.useColorModeValue('gray.400', 'whiteAlpha.700');

    return (
        <>
            {/* Back to previous page Section */}
            <CC.HStack>
                <Link
                to={
                    URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU.OPPOSITION
                }
                >
                <CC.Box
                    borderRadius={'50%'}
                    p={'0.5rem'}
                    _hover={{ backgroundColor: `${bg}` }}
                >
                    <FaArrowLeft size={'1.5rem'} />
                </CC.Box>
                </Link>

                <CC.Hide below="md">
                <CC.Heading size="lg">Détails carte opposées</CC.Heading>
                </CC.Hide>

                <CC.Show below="md">
                <CC.Heading size="lg">Retour</CC.Heading>
                </CC.Show>
            </CC.HStack>

            <CC.Divider my={'2rem'} />

            <OpposingCardDetailsHandler />
        </>
    );
};

export default OppositionDetailPage;
